<template>
  <div>
    <!-- Loading -->
    <div>
      <b-row v-if="isLoading">
        <b-col>
          <LoadingSpinner></LoadingSpinner>
        </b-col>
      </b-row>
    </div>
    <div v-if="!isLoading">
      <!-- actions -->
      <b-row class="pb-3">
        <!-- year select -->
        <b-col cols="auto">
          <b-input-group>
            <b-form-select v-model="selectedYear" id="yearSelected" :options="yearOptions"></b-form-select>
          </b-input-group>
        </b-col>
        <!-- search -->
        <b-col cols="auto">

          <b-form-select v-model="selectedTeacherFilter" :options="teacherOptions"></b-form-select>

          <!--  <b-form-input
          @keyup.enter="filtrar()"
          @keyup.esc="cancelFilterSearch()"
          v-model="searchFilter"
          type="text" placeholder="Buscar..."></b-form-input>
        <b-input-group-append>
          <b-button variant="outline-secondary" @click="filtrar()"><b-icon icon="search"/></b-button>
          <b-button @click="cancelFilterSearch()"
          v-if="searchFilter !== ''" variant="outline-secondary"><b-icon icon="x"/></b-button>
        </b-input-group-append> -->

        </b-col>
        <b-col cols="auto">
          <b-form-select v-model="selectedCourseFilter" :options="courseOptions"></b-form-select>
        </b-col>
        <b-col cols="auto">
          <b-form-select v-model="selectedRoomFilter" :options="roomOptions"></b-form-select>
        </b-col>
        <!-- add -->
        <b-col class="ml-auto" v-if="$store.state.user.currentGroups.includes('Dirección')">
          <b-button id="buttonmasclase" @click="newClase()" class="btn-agregar-modelo" variant="primary">
            <b-icon icon="plus"></b-icon>Agregar
          </b-button>
        </b-col>
        <!-- <b-col class="ml-auto" v-if="$store.state.user.currentGroups.includes('Dirección')">
          <b-button id="buttonmasclase" @click="syncYear()" class="btn-agregar-modelo" variant="primary">
            <b-icon icon="plus"></b-icon>Sincronizar con Año
          </b-button>
        </b-col> -->
      </b-row>
      <!-- Loading -->
      <b-row v-if="isLoading">
        <b-col>
          <LoadingSpinner></LoadingSpinner>
        </b-col>
      </b-row>
      <!-- table -->
      <b-row v-if="!isLoading">
        <b-col>
          <b-card title="Listado de clases">
            <b-table sticky-header no-border-collapse striped style="min-height: 65vh;" :items="classes"
              :fields=classesFields head-variant="light">
              <template v-slot:head(x_name)="data">
                <span v-html="data.label"></span>
              </template>
              <template v-slot:head(x_teacher_id)="data">
                <span v-html="data.label"></span>
              </template>
              <template v-slot:head(x_capacity)="data">
                <span v-html="data.label"></span>
              </template>
              <!-- <template v-slot:head(x_cancelled)="data">
                <span v-html="data.label"></span>
              </template> -->
              <template v-slot:head(x_room_id)="data">
                <span v-html="data.label"></span>
              </template>
              <!-- Classes: Provides link to class -->
              <template #cell(x_name)="data">
                <b-link style="width: 100px;" @click="$router.push({ path: '/classes/' + data.item.id })">{{
        data.item.x_name }}</b-link>
              </template>
              <!-- Teachers: Shows teacher name from ID array -->
              <template #cell(x_teacher_id)="data">
                {{ data.item.x_teacher_id[1] }}
              </template>
              <!-- Capacity: Shows number of enrollments/capatity -->
              <template #cell(x_capacity)="data">
                <b-progress v-if="data.item.x_enrollments_ids" class="mt-1" :max="data.item.x_capacity">
                  <b-progress-bar :value="(data.item.x_enrollments_ids.length - data.item.x_cancelled)"
                    variant='primary'
                    :label="`${(data.item.x_enrollments_ids.length - data.item.x_cancelled)}/ ${data.item.x_capacity}`">
                  </b-progress-bar>
                </b-progress>

                <!-- <b-progress v-if="data.item.x_enrollments_ids" value="50" max="100"></b-progress> -->
              </template>
              <!-- Bajas: shows number of cancelled enrollments for each class  -->
              <!-- <template #cell(x_cancelled)="data">
                {{ data.item.x_cancelled && data.item.x_cancelled }}
              </template> -->
              <!-- Rooms: Shows room name from room ID  -->
              <template #cell(x_room_id)="data">
                {{ data.item.x_room_id[1] }}
              </template>
              <!-- Actions section -->
              <template #cell(actions)="data">
                <b-dropdown variant="outline-secondary" text="">
                  <b-dropdown-item @click="$router.push({ path: '/classes/' + data.item.id })">Ver</b-dropdown-item>
                  <b-dropdown-divider v-if="$store.state.user.currentGroups.includes('Dirección')"></b-dropdown-divider>
                  <b-dropdown-item @click="editarClase(data.item)"
                    v-if="$store.state.user.currentGroups.includes('Dirección')">Editar</b-dropdown-item>
                  <b-dropdown-item @click="eliminarClase(data.item)"
                    v-if="$store.state.user.currentGroups.includes('Dirección')">Eliminar</b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </b-card>
        </b-col>
      </b-row>
      <b-modal id="modal-ver-inscriptos" size="xl" title="Ver Inscriptos">
        <view-class-enrollments :enrollments_ids="pop_up_enrollments_ids"></view-class-enrollments>
      </b-modal>
      <b-modal id="modal-ver-venta" size="xl" :title="modalSaleOrderTitle">
        <ver-venta :order_id="modalSaleOrderId"></ver-venta>
      </b-modal>
      <new-class></new-class>
      <edit-class :item="editClassItem" @updateClases="filtrar()"></edit-class>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from './../components/LoadingSpinner.vue'
import VerVenta from './VerVenta.vue'

import viewClassEnrollments from '../components/pop-ups/viewClassEnrollments.vue'
import newClass from '../components/pop-ups/newClass.vue'
import editClass from '../components/pop-ups/editClass.vue'
// import { YearsService } from '@/services/years.service'
import { FamiliesService } from '@/services/families.service'
import { ClassesService } from '@/services/classes.service'
import { TeacherService } from '@/services/teacher.service'
import { CoursesService } from '@/services/courses.service'
// import { EnrollmentsService } from '@/services/enrollments.service'
import { RoomService } from '@/services/room.service'
import { ScheduleService } from '@/services/schedule.service'
import { SaleOrdersService } from '@/services/sale.orders.service'
import { YearsService } from '@/services/years.service'

export default {
  name: 'Clases',
  components: {
    VerVenta,
    viewClassEnrollments,
    newClass,
    editClass,
    LoadingSpinner
  },
  data () {
    return {
      isLoading: true,
      years: [],
      selectedYear: null,
      classesFields: [
        { key: 'x_name', label: 'Nombre', sortable: true, sortDirection: 'desc' },
        { key: 'x_teacher_id', label: 'Docente', sortable: true },
        { key: 'x_capacity', label: 'Capacidad' },
        { key: 'x_room_id', label: 'Aula', sortable: true },
        { key: 'actions', label: 'Acciones' }
      ],
      classes: [],
      courses: [],
      rooms: [],
      teachers: [],
      pop_up_enrollments_ids: [],
      year: null,
      filter: '',
      editClassItem: {},
      modalSaleOrderTitle: '',
      searchFilter: '',
      modalSaleOrderId: null,
      selectedTeacherFilter: null,
      selectedCourseFilter: null,
      selectedRoomFilter: null,
      domain: {}
    }
  },
  watch: {
    async selectedTeacherFilter () {
      this.isLoading = true
      this.domainCalculate()

      this.classes = await ClassesService.listWithCancelled(this.domain, { limit: 0, order: 'x_name asc' })
      this.isLoading = false
    },
    async selectedCourseFilter () {
      this.isLoading = true
      this.domainCalculate()

      this.classes = await ClassesService.listWithCancelled(this.domain, { limit: 0, order: 'x_name asc' })
      this.isLoading = false
    },
    async selectedRoomFilter () {
      this.isLoading = true
      this.domainCalculate()

      this.classes = await ClassesService.listWithCancelled(this.domain, { limit: 0, order: 'x_name asc' })
      this.isLoading = false
    },
    async selectedYear (n, o) {
      this.domainCalculate()
      this.classes = await ClassesService.listWithCancelled(this.domain, { limit: 0, order: 'x_name asc' })
      // console.log('clases CON BAJAS: ', this.classes)
      this.isLoading = false
    }
  },

  computed: {
    yearOptions () {
      // console.log('loading years options...')
      const opts = []
      for (var i = 0; i < this.years.length; i++) {
        opts.push({ value: this.years[i].id, text: this.years[i].x_year })
      }
      return opts
    },
    teacherOptions () {
      // console.log('loading teacher options...')
      const opts = [{ value: null, text: 'Docente' }]
      for (var i = 0; i < this.teachers.length; i++) {
        opts.push({ value: this.teachers[i].id, text: this.teachers[i].x_name })
      }
      return opts
    },
    courseOptions () {
      // console.log('loading courses options...')
      const opts = [{ value: null, text: 'Curso' }]
      for (var i = 0; i < this.courses.length; i++) {
        opts.push({ value: this.courses[i].id, text: this.courses[i].name })
      }
      return opts
    },
    roomOptions () {
      // console.log('loading room options...')
      const opts = [{ value: null, text: 'Aula' }]
      for (var i = 0; i < this.rooms.length; i++) {
        opts.push({ value: this.rooms[i].id, text: this.rooms[i].x_name })
      }
      return opts
    },
    capacityPercentage (capacity, cancelled, total) {
      const maxRoom = capacity
      const totalStudents = total - cancelled
      const barValue = totalStudents >= maxRoom ? 100 : (totalStudents * 100 / maxRoom)
      const barColor = barValue > 70 ? 'success' : barValue > 40 ? 'warning' : 'danger'
      return { barValue: barValue, barColor: barColor }
    }

  },
  async created () {
    this.isLoading = true
    this.years = this.$store.state.year.list
    this.year = this.$store.state.year.selected
    this.teachers = await TeacherService.list({ x_active: true })
    this.courses = await CoursesService.list({})
    this.rooms = await RoomService.list({})
    this.selectedYear = this.year.id
    this.isLoading = false
  },
  methods: {
    domainCalculate () {
      this.domain = { x_year_id: this.selectedYear }
      // console.log(this.domain)
      if (this.$store.state.user.currentGroups.includes('Docentes')) {
        if (!this.$store.state.user.currentGroups.includes('Coordinación')) {
          this.domain.x_teacher_id = this.$store.state.user.currentUser.x_teacher_id[0]
        }
      } else {
        if (this.selectedTeacherFilter !== null) {
          this.domain.x_teacher_id = this.selectedTeacherFilter
        }
      }
      if (this.selectedCourseFilter !== null) {
        this.domain.x_product_template_id = this.selectedCourseFilter
      }
      if (this.selectedRoomFilter !== null) {
        this.domain.x_room_id = this.selectedRoomFilter
      }
    },
    async filtrar () {
      this.isLoading = true
      this.classes = await ClassesService.listWithCancelled([
        ['x_year_id', '=', this.selectedYear],
        ['x_name', 'ilike', this.searchFilter]
      ], { limit: 0, order: 'x_name asc' })

      this.isLoading = false
    },
    async eliminarClase (item) {
      const schedule = await ScheduleService.search({ x_class_id: item.id })
      await ScheduleService.delete(schedule)
      await ClassesService.delete(item.id)
      this.classes = await ClassesService.listWithCancelled({ x_year_id: this.selectedYear }, { limit: 0, order: 'x_name asc' })
    },
    async editarClase (item) {
      this.editClassItem = item
      this.$session.set('editClassItem', item)
      this.$bvModal.show('edit-clase')
    },
    async newClase () {
      this.editClassItem = {}
      this.$bvModal.show('new-clase')
    },
    async syncYear () {
      // console.log('classes : all ---- ', this.classes)
      // console.log('selected year ', this.selectedYear)
      for (let i = 0; i < this.classes.length; i++) {
        const yearData = await YearsService.read([this.classes[i].x_year_id[0]], [])
        if (yearData) {
          // console.log('year data: ', yearData[0].x_year)
          const updateClass = await ClassesService.update(this.classes[i].id, { x_year: yearData[0].x_year })
          if (updateClass) {
            console.log('done ')
          }
        }
      }
    },
    async verVenta (item) {
      const so = await SaleOrdersService.list({ name: item })
      this.modalSaleOrderId = so[0].id
      this.modalSaleOrderTitle = so[0].display_name + ' - ' + so[0].create_date
      this.$bvModal.show('modal-ver-venta')
    },
    async verFamilia (item) {
      const student = await FamiliesService.read([item.x_student_id[0]], [])
      this.$router.push({ path: '/families/' + student[0].parent_id[0] })
    },
    async verInscriptos (item) {
      this.pop_up_enrollments_ids = item.x_enrollments_ids
      this.$bvModal.show('modal-ver-inscriptos')
    },
    cancelFilterSearch () {
      this.searchFilter = ''
      this.classes = []
      this.filtrar()
    }
  }
}
</script>

<style lang="scss" scoped></style>
